import React from 'react';
import * as mobxReact from 'mobx-react';
import * as mobx from 'mobx';
import { injectIntl, IntlShape } from 'react-intl';
import { CommonPopupBodyFooterLayout } from '../../../../global/common-popup/common-popup-body-footer-layout';
import { DefaultCloseSubWindowButton } from '../../../../global/sub-window/common/common-close-sub-window-buttons';
import { RichTextEditor } from '../../../../global/rich-text-editor';
import { FormField } from '../../../../global/form/form-field/form-field';
import GuidelinesFormVM from './guidelines-form.viewmodel';
import './guidlines-form.scss';
import { CANCEL_TEXT, DONE_TEXT } from '../../../../../constants/common-labels.constants';

interface IGuidelinesFormPresentation {
    vm: GuidelinesFormVM;
    intl: IntlShape;
}

const GuidelinesFormPresentation = injectIntl(mobxReact.observer(({ vm, intl }: IGuidelinesFormPresentation) => {

    return (
        <CommonPopupBodyFooterLayout
            emptyGuidelines={!vm.getEventNotes() && !vm.isEditMode}
            body={(
                vm.isEditMode ? <form className='oe-form guidelines-form' onSubmit={vm.formSubmitAction}>
                    <div className='oe-form__body'>
                        <FormField label={intl.formatMessage({
                            id: 'oe.control.eventGuidelines',
                            defaultMessage: 'Event Guidelines',
                            description: 'Label text'
                        })}>
                            <RichTextEditor
                                id='event-guidelines'
                                value={vm.getEventNotes()}
                                className={'guidelines-editor'}
                                onChange={mobx.action((event, editor) => {
                                    vm.setEventNotes(editor.getData());
                                })}
                                validationError={vm.getEventNotesLengthError()}
                            />
                        </FormField>
                    </div>
                </form> : <div className='guidelines-wrapper'
                    dangerouslySetInnerHTML={{
                        __html: vm.getEventNotes() || intl.formatMessage({
                            id: 'oe.control.emptyGuidelines',
                            defaultMessage: 'No guidelines have been provided',
                            description: 'Empty guidelines message'
                        })
                    }} />
            )}
            footer={
                vm.isEditMode && <>
                    {vm.isSaving && intl.formatMessage({
                        id: 'oe.control.guidelinesIsBeingSaved',
                        description: 'Placeholder about saving guidelines',
                        defaultMessage: 'Guidelines is being saved, please wait...',
                    })}
                    <div className='buttons-block buttons-block--from-right'>
                        <DefaultCloseSubWindowButton
                            text={intl.formatMessage(DONE_TEXT)}
                            onClick={vm.formSubmitAction}
                            modifier={['fat', 'confirm-safe']}
                            disabled={vm.getEventNotesError() || vm.isSaving}
                        />
                        <DefaultCloseSubWindowButton
                            text={intl.formatMessage(CANCEL_TEXT)}
                            onClick={() => {
                                vm.trackGuidelinesMixPanel(vm.openFrom, false);
                                return true;
                            }}
                        />
                    </div>
                </>
            }
        />
    );
}));

export { GuidelinesFormPresentation };
